import React from 'react';
import {CircularProgress} from '@material-ui/core';
import useMrssDefaults from '@pluto/mrss-defaults-hook';
import {maybeArray} from '@pluto/maybe-array';
import {onChangeMultiSelect} from '@pluto/react-select-mapping';
import MrssDefaultMultiSelector from './MrssDefaultMultiSelector';

export interface MrssDefaultsProps {
    setMrssDefaults: () => void;
    mrssDefaults: {
        isLoading: boolean;
        data: {
            key: string;
        };
    };
    onChange: (val: string) => void;
    value: string | string[];
    variant: string;
    mrssDefaultOption: string;
    isMulti?: boolean;
    selectorType?: string;
}

export const mapToMultiSelectValue = (item: any) => ({
    value: item,
    label: item,
});

export const getSelectOptions = (params: any) => {
    const {data, mrssDefaultOption} = params;

    return data[mrssDefaultOption]?.map(mapToMultiSelectValue);
};

export const getMrssDefaultsValue = (value: any) => {
    if (!value) return [];

    const arrayValue = maybeArray(value);

    return arrayValue.map(mapToMultiSelectValue);
};

export default function MrssDefaultsContainer(props: MrssDefaultsProps) {
    const {
        setMrssDefaults,
        mrssDefaults,
        onChange,
        value,
        variant,
        mrssDefaultOption,
        isMulti,
        selectorType = 'react',
    } = props;
    const {isLoading, data} = mrssDefaults;

    useMrssDefaults({
        setMrssDefaults,
        mrssDefaults,
    });

    if (isLoading) {
        return <CircularProgress />;
    }

    const options = getSelectOptions({
        data,
        mrssDefaultOption,
    });
    const selectValue = getMrssDefaultsValue(value);
    const onChangeDefaultMultiSelector = onChangeMultiSelect({
        onFieldChange: onChange,
        isMulti,
        isPolling: false,
    });

    return (
        <MrssDefaultMultiSelector
            isMulti={isMulti}
            value={selectValue}
            onChange={selectorType === 'react' ? onChangeDefaultMultiSelector : onChange}
            options={options}
            variant={variant}
            selectorType={selectorType}
        />
    );
}
